
import { stringify } from "query-string";

export const buildQueryUrl = (base: string, params: any = null) => {
    const url = new URL(base);
    if (params) {
        url.search = stringify(params)
    }

    return url.toString();
}


